import { Alert, Typography, Link as MuiLink } from "@mui/material";
import React from "react";
import { useContacts } from "../../hooks/useContacts";
import { useReadingEmail } from "../../hooks/useReadingEmail";
import { ContactType } from "../../models/ContactModels";
import { Link } from "react-router-dom";

export function ContactAlert() {
  const { emailAddress } = useReadingEmail();
  const { contacts, ...contactsResponse } = useContacts(emailAddress);
  const suppliers = contacts?.filter(
    ({ type }) => type === ContactType.Supplier || type === ContactType.SupplierCustomer
  );
  const customers = contacts?.filter(
    ({ type }) => type === ContactType.Customer || type === ContactType.SupplierCustomer
  );

  if (contactsResponse.isLoading || contactsResponse.isError) {
    return null;
  }

  if (!suppliers?.length && !customers?.length) {
    const emailDomain = emailAddress?.split("@")[1] ?? "";
    return (
      <Alert severity="error" icon={false}>
        <Typography>
          No contact has this domain:{" "}
          <MuiLink component={Link} to="/contacts">
            {emailDomain}
          </MuiLink>
        </Typography>
      </Alert>
    );
  }

  return (
    <Alert severity="success" icon={false}>
      <Typography>
        Found{" "}
        <MuiLink component={Link} to="/contacts">
          contacts
        </MuiLink>{" "}
        with this domain
      </Typography>
    </Alert>
  );
}
